// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__fCQcg","errorMessage":"Checkbox_errorMessage__q1ovv","error":"Checkbox_error__U3WMe"};